export default __webpack_public_path__ + "static/Locations-full-1f10121f019c5a04bbcb3ab140a27789.jpg";